import{transparentize as zr}from"polished";var c=(e,o)=>zr(1-e,o);var t={transparent:"transparent",black:"rgb(0, 0, 0)",white:"rgb(255, 255, 255)",blue:{50:"rgb(225, 246, 254)",75:"rgb(217, 233, 243)",100:"rgb(180, 230, 254)",150:"rgb(135, 191, 224)",200:"rgb(131, 214, 253)",300:"rgb(79, 199, 251)",400:"rgb(40, 186, 251)",500:"rgb(0, 174, 249)",600:"rgb(0, 159, 234)",700:"rgb(0, 140, 214)",800:"rgb(0, 123, 194)",850:"rgb(0, 113, 178)",900:"rgb(1, 102, 160)",950:"rgb(1, 57, 102)",1e3:"rgb(0, 36, 64)"},grey:{50:"rgb(250, 250, 250)",100:"rgb(245, 245, 245)",200:"rgb(238, 238, 238)",300:"rgb(224, 224, 224)",400:"rgb(189, 189, 189)",500:"rgb(158, 158, 158)",600:"rgb(117, 117, 117)",700:"rgb(97, 97, 97)",800:"rgb(66, 66, 66)",900:"rgb(38, 38, 38)",1e3:"rgb(20, 20, 20)"},red:{50:"rgb(247, 209, 209)",100:"rgb(244, 186, 186)",200:"rgb(240, 163, 163)",300:"rgb(232, 117, 117)",350:"rgb(228, 94, 94)",400:"rgb(225, 71, 71)",500:"rgb(217, 25, 25)",600:"rgb(195, 23, 23)",700:"rgb(174, 20, 20)",800:"rgb(152, 18, 18)",900:"rgb(130, 15, 15)",1e3:"rgb(109, 13, 13)",1100:"rgb(87, 10, 10)"},purple:{500:"rgb(197, 138, 249)",800:"rgb(104, 29, 168)"}};function jt(e,o){return Array.isArray(e)&&e.length===2?e[o]:Object.entries(e).reduce((r,[a,i])=>(r[a]=jt(i,o),r),{})}function eo(e,o){return Object.entries(e).reduce((r,[a,i])=>(r[a]=jt(i,o),r),{})}var he=[t.blue[800],t.blue[400]],Wr=[t.grey[50],t.grey[1e3]],Ur=[t.blue[50],t.blue[1e3]],Ie=[t.grey[900],t.white],Or=[t.grey[700],t.grey[300]],Nr=[t.grey[500],t.grey[500]],D=[t.grey[300],t.grey[800]],Qt=[t.grey[500],t.grey[500]],Yt=[t.grey[700],t.grey[200]],pt=[c(.1,t.blue[800]),c(.1,t.blue[400])],mt=[c(.2,t.blue[800]),c(.2,t.blue[400])],ut=[c(.05,t.black),c(.1,t.white)],gt=[c(.1,t.black),c(.2,t.white)],_r=[t.blue[900],t.blue[300]],ft=[t.grey[200],t.grey[800]],Zr=[t.red[500],t.red[350]],Xr=[c(.75,t.black),c(.5,t.white)],to={accent:he,background:Wr,backdrop:Xr,emptyStateCard:Ur,stroke:{light:[t.grey[300],t.grey[800]],mid:[t.grey[500],t.grey[600]],dark:[t.grey[700],t.grey[400]],dark2:[t.grey[800],t.grey[300]]},mainText:Ie,secondaryText:Or,notes:Nr,disabledContent:D,iconDefault:Qt,action:Yt,blueHover:pt,bluePress:mt,greyHover:ut,greyPress:gt,focus:_r,group:ft,alert:Zr,buttons:{primary:{default:[t.blue[800],t.blue[800]],hover:[t.blue[850],t.blue[700]],pressed:[t.blue[900],t.blue[600]],disabled:[t.blue[75],t.blue[1e3]],content:[t.white,t.white],disabledContent:[t.blue[150],t.blue[900]]},secondary:{default:[t.transparent,t.transparent],hover:pt,pressed:mt,disabled:[t.transparent,t.transparent],content:he,disabledContent:D},teritary:{default:[t.grey[200],t.grey[800]],hover:[t.grey[300],t.grey[700]],pressed:[t.grey[400],t.grey[600]],disabled:[t.grey[100],t.grey[900]],content:[t.grey[800],t.grey[200]],disabledContent:D},embedded:{default:[t.transparent,t.transparent],hover:ut,hoverOnDark:[c(.1,t.white),c(.1,t.white)],pressed:gt,pressedOnDark:[c(.2,t.white),c(.2,t.white)],disabled:[t.transparent,t.transparent],content:[t.grey[700],t.white],contentOnDark:[t.grey[200],t.grey[200]],disabledContent:D},secondaryOutlined:{default:[t.grey[200],t.grey[800]],hover:[t.grey[300],t.grey[700]],pressed:[t.grey[400],t.grey[600]],content:[t.grey[800],t.grey[200]]},link:{default:he,hover:[t.blue[900],t.blue[300]],pressed:[t.blue[950],t.blue[200]],used:[t.purple[800],t.purple[500]],disabled:D},buttonTile:{default:[t.grey[200],t.grey[800]],hover:[t.grey[300],t.grey[700]],pressed:[t.grey[400],t.grey[600]],disabled:[t.grey[100],t.grey[900]],text:he,disabledText:[t.grey[300],t.grey[700]]},cardButton:{default:[t.white,t.grey[900]],hover:pt,pressed:mt,text:he},primaryDestructive:{defaultBackgroud:[t.red[500],t.red[500]],defaultContent:[t.white,t.white],hoverBackground:[t.red[600],t.red[400]],hoverContent:[t.white,t.white],pressedBackground:[t.red[700],t.red[350]],pressedContent:[t.white,t.white],disabledBackground:[t.red[50],t.red[1e3]],disabledContent:[t.red[100],t.red[900]],inProgressBackground:[t.red[50],t.red[1e3]],inProgressContent:[t.red[100],t.red[900]]},secondaryDestructive:{defaultBackgroud:[t.transparent,t.transparent],defaultContent:[t.red[500],t.red[500]],hoverBackground:[c(.1,t.red[500]),c(.1,t.red[500])],hoverContent:[t.red[500],t.red[500]],pressedBackground:[c(.2,t.red[500]),c(.2,t.red[500])],pressedContent:[t.red[500],t.red[500]],disabledBackground:[t.transparent,t.transparent],disabledContent:D,inProgressBackground:[t.transparent,t.transparent],inProgressContent:D},flatDestructive:{defaultBackgroud:[t.transparent,t.transparent],defaultContent:[t.red[500],t.red[500]],hoverBackground:[c(.1,t.red[500]),c(.1,t.red[500])],hoverContent:[t.red[500],t.red[500]],pressedBackground:[c(.2,t.red[500]),c(.2,t.red[500])],pressedContent:[t.red[500],t.red[500]],disabledBackground:[t.transparent,t.transparent],disabledContent:D,inProgressBackground:[t.transparent,t.transparent],inProgressContent:D}},tooltips:{fill:ft,content:Ie,shadow:[c(.25,t.black),c(.25,t.black)]},hint:{fill:[t.blue[800],t.blue[950]],content:[t.white,t.white],shadow:[c(.25,t.black),c(.25,t.black)]},checkbox:{defaultText:Ie,defaultFill:[t.blue[800],t.blue[600]],hover:[t.blue[600],t.blue[700]],pressed:[t.blue[400],t.blue[800]],disabled:[t.grey[300],t.grey[800]]},radioButton:{defaultText:Ie,defaultFill:[t.blue[800],t.blue[600]],hover:[t.blue[600],t.blue[700]],pressed:[t.blue[400],t.blue[800]],disabled:[t.grey[300],t.grey[800]]},toggle:{shadow:[c(.3,t.black),c(.3,t.black)],on:{defaultHandle:[t.blue[800],t.blue[600]],defaultTrack:[t.blue[600],t.blue[800]],hoverHandle:[t.blue[600],t.blue[400]],hoverTrack:[t.blue[400],t.blue[600]],disabledHandle:[t.blue[50],t.blue[950]],disabledTrack:[t.blue[50],t.blue[950]]},off:{defaultHandle:[t.grey[300],t.grey[400]],defaultTrack:[t.grey[500],t.grey[600]],hoverHandle:[t.grey[200],t.grey[300]],hoverTrack:[t.grey[400],t.grey[500]],disabledHandle:[t.grey[100],t.grey[800]],disabledTrack:[t.grey[200],t.grey[800]]}},dataUsageBar:{used:[t.blue[600],t.blue[700]],total:ft},menu:{fill:[t.white,t.grey[900]],shadow:[c(.25,t.black),c(.25,t.black)],itemFill:[t.transparent,t.transparent],itemContent:Yt,itemIcon:Qt,itemHoverFill:ut,itemPressedFill:gt,itemDisabledContent:D},thumbnail:{contentOnDark:[t.white,t.white],collectionOutline:[t.blue[500],t.blue[500]]}},Kr=eo(to,0),Us=eo(to,1);import Me from"styled-components";import*as _ from"@radix-ui/react-accordion";import{jsx as oo}from"react/jsx-runtime";var qr=e=>oo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:oo("path",{fill:e.color??"currentColor",d:"M12 15.97c-.133 0-.258-.02-.375-.063a.876.876 0 0 1-.325-.212l-4.6-4.6a.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275l3.9 3.9 3.9-3.9a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7l-4.6 4.6c-.1.1-.208.17-.325.212a1.106 1.106 0 0 1-.375.063"})}),ro=qr;import Y,{css as U}from"styled-components";var n={25:"0.25rem",50:"0.5rem",75:"0.75rem",100:"1rem",125:"1.25rem",150:"1.5rem",200:"2rem",250:"2.5rem",300:"3rem",350:"3.5rem",400:"4rem"},d={small:"0.25rem",medium:"0.5rem",mediumLarge:"0.75rem",large:"1rem",round:"99px"},s={innerGap:n[50],componentInlinePadding:n[75],horizontalComponentGap:n[100]},$={xSmall:n[150],small:n[200],medium:n[250],large:n[300],xLarge:n[350]};var be=U`
    line-height: normal;
    font-size: 1rem; // 16px
`,h=U`
    line-height: normal;
    font-size: 1rem; // 16px
`,xe=U`
    line-height: normal;
    font-size: 0.75rem; // 12px
`,O=U`
    line-height: normal;
    font-size: 0.875rem; // 14px
`,no=U`
    line-height: normal;
    font-size: 1.25rem; // 20px
`,ht=U`
    color: ${({theme:e})=>e.mainText};
`,bt=U`
    margin: 0;
`,xt=U`
    /* reset */
    ${bt}

    /* content */
    ${ht}
    ${be}
`,Jr=Y.h2`
    /* reset */
    ${bt}
    font-weight: 700;

    /* content */
    ${ht}
    font-size: 1.375rem; // 22px
`,Qr=Y.h3`
    /* reset */
    ${bt}

    /* content */
    ${ht}
    font-weight: 700;
    font-size: 1.125rem; // 18px
`,Yr=Y.p`
    ${xt}
`,jr=Y.strong`
    font-weight: 700;
`,en=Y.span`
    color: ${({theme:e})=>e.notes};
    font-size: 0.75rem; // 12px
`,tn=Y.a`
    /* reset */
    cursor: pointer;

    /* content */
    color: ${({theme:e})=>e.buttons.link.default};
    text-decoration: underline;
    text-underline-offset: ${n[25]};

    &:hover {
        color: ${({theme:e})=>e.buttons.link.hover};
    }

    &:active {
        color: ${({theme:e})=>e.buttons.link.pressed};
    }

    &:visited {
        color: ${({theme:e})=>e.buttons.link.used};
    }
`,on=Y.hr`
    border: none;
    border-top: 1px solid ${({theme:e})=>e.stroke.light};
`,p={Divider:on,SectionHeader:Jr,Subheader:Qr,Paragraph:Yr,Bold:jr,Link:tn,Secondary:en};import{forwardRef as an}from"react";import{mergeProps as ln,useButton as sn,useFocusRing as dn,useHover as cn}from"react-aria";import pn,{css as De}from"styled-components";import{ProgressBar as rn}from"react-aria-components";import{jsx as Ae,jsxs as nn}from"react/jsx-runtime";function ao(e){return Ae(rn,{...e,children:nn("svg",{width:"24",height:"24",viewBox:"0 0 24 24",style:{display:"block"},children:[Ae("path",{fill:"currentColor",d:"M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",opacity:".25"}),Ae("path",{fill:"currentColor",d:"M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",children:Ae("animateTransform",{attributeName:"transform",type:"rotate",dur:"0.75s",values:"0 12 12;360 12 12",repeatCount:"indefinite"})})]})})}import{jsx as io,jsxs as mn}from"react/jsx-runtime";var y=De`
    all: unset;
    cursor: pointer;
    user-select: none;
    box-sizing: border-box;
`,ee=De`
    min-width: 104px;
    width: fit-content;
    padding-inline: ${s.componentInlinePadding};
    display: flex;
    align-items: center;
    gap: ${s.innerGap};
    justify-content: center;
`,ye=De`
    border-radius: ${d.small};
    border-width: 1px;
    border-style: solid;
`,N=De`
    /* layout */
    padding-inline: 0;
    justify-content: center;

    width: ${({$variant:e})=>j(e)};
    min-width: ${({$variant:e})=>j(e)};
`,lo=an(function(o,r){let{onPress:a,icon:i,isDisabled:l,isPending:g,propagateWhenDisabled:u,...x}=o,k=u||!l?a:void 0,{buttonProps:oe,isPressed:re}=sn({onPress:k},r),{focusProps:lt,isFocused:st,isFocusVisible:dt}=dn(o),{hoverProps:Re,isHovered:V}=cn(o),fe=ln(x,oe,lt,Re),{onHoverChange:Kt,onHoverStart:qt,onHoverEnd:Jt,...ct}=fe,Lr=function(){return g?io(ao,{"aria-label":"Pending\u2026"}):i?io(i,{color:"currentColor"}):null}();return mn("button",{...ct,type:o.type,disabled:l,"data-disabled":l||void 0,"data-pending":g||void 0,"data-pressed":re||void 0,"data-hovered":V||void 0,"data-focused":st||void 0,"data-focus-visible":dt||void 0,ref:r,children:[Lr,o.children]})});lo.displayName="ReactAriaButton";function j(e){switch(e){case"large":return $.large;case"medium":return $.medium;case"small":return $.small}}var v=pn(lo)`
    /* reset */
    ${y}

    /* layout */
    ${ee}

    /* content */
    ${h}

    /* appearance */
    ${ye}

    &[data-disabled], &[data-pending] {
        cursor: not-allowed;
    }
    &[data-focus-visible] {
        outline: ${({theme:e})=>e.focus} solid 1px;
    }

    height: ${({$variant:e})=>j(e)};
    width: ${({$fluid:e})=>e?"100%":"fit-content"};
`;import{jsx as ve,jsxs as so}from"react/jsx-runtime";var un=Me(_.Trigger)`
    /* reset */
    ${y}

    /* layout */
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${n[25]};
    padding-inline: ${s.componentInlinePadding};

    /* appearance */
    border-radius: ${d.small};

    .expand-icon {
        transition: transform 0.3s;
    }

    &[data-state='open'] {
        .expand-icon {
            transform: rotate(180deg);
        }
    }

    &:hover {
        background-color: ${({theme:e})=>e.greyHover};
    }

    &:active {
        background-color: ${({theme:e})=>e.greyPress};
    }
`,gn=Me(p.Divider)`
    margin-inline: ${s.componentInlinePadding};
    margin-block: ${n[25]} ${n[50]};
`,fn=Me(_.Root)`
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
`,hn=({children:e,...o})=>so(un,{...o,children:[ve(p.SectionHeader,{children:e}),ve(ro,{className:"expand-icon","aria-hidden":!0})]}),bn=Me(_.Content)`
    /* reset content */
    ${xt}

    /* layout */
    padding-inline: ${s.componentInlinePadding};
    display: flex;
    flex-direction: column;
    gap: 1rem;
`,xn=({title:e,children:o,...r})=>so(_.AccordionItem,{value:e,...r,children:[ve(hn,{children:e}),ve(gn,{}),ve(bn,{children:o})]});import L from"styled-components";var co='data:image/svg+xml,<svg width="282" height="282" viewBox="0 0 282 282" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M252.377 75.6069H29.6228V221.45H252.377V75.6069Z" fill="%2300ABFA"/>%0A<path d="M149.164 220.61C149.164 225.119 145.509 228.774 141 228.774C136.491 228.774 132.836 225.119 132.836 220.61" fill="%2300ABFA"/>%0A<path d="M143.92 215.787C143.92 215.787 199.637 192.698 246.296 215.787H143.92Z" fill="%23016EC4"/>%0A<path d="M143.001 79.3761C143.001 79.3761 198.266 66.1972 246.092 79.3761L246.304 216.478C246.304 216.478 206.13 194.159 144.061 215.416L142.999 79.3761H143.001Z" fill="%23D9F5FF"/>%0A<path d="M38.3994 210.56C38.3994 210.56 94.5919 201.004 138.141 215.873L38.3413 216.191L38.3994 210.56Z" fill="%23016EC4"/>%0A<path d="M139.542 216.017C139.542 216.017 87.194 199.374 36.0801 213.52V76.2102C36.0801 76.2102 75.2384 54.1573 139.542 79.955V216.017Z" fill="%23D9F5FF"/>%0A<path d="M236.133 105.824H184.666V157.292H236.133V105.824Z" fill="white"/>%0A<path d="M231.604 110.352H189.193V152.762H231.604V110.352Z" fill="%23D9F5FF"/>%0A<path d="M220.991 115.747H169.523V167.215H220.991V115.747Z" fill="white"/>%0A<path d="M216.463 120.275H174.053V162.685H216.463V120.275Z" fill="%23B2C1FF"/>%0A<path d="M202.829 125.696H151.361V177.164H202.829V125.696Z" fill="white"/>%0A<path d="M198.3 130.224H155.889V172.634H198.3V130.224Z" fill="%23016EC4"/>%0A<path d="M198.3 159.127H155.889V172.634H198.3V159.127Z" fill="%2341BAFA"/>%0A<path d="M169.523 159.128C169.523 154.946 172.912 151.557 177.093 151.557C181.275 151.557 184.663 154.946 184.663 159.128" fill="%23D9F5FF"/>%0A<path d="M102.379 93.7502H52.5935V143.536H102.379V93.7502Z" fill="white"/>%0A<path d="M97.9995 98.1301H56.9753V139.154H97.9995V98.1301Z" fill="%23016EC4"/>%0A</svg>%0A';var po='data:image/svg+xml,<svg width="332" height="332" viewBox="0 0 332 332" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_4102_4121)">%0A<path d="M331.31 0H0V331.31H331.31V0Z" fill="%23EEEEEE"/>%0A<path d="M0 272.29L110.05 165.66L173.49 245.68L259.84 107.82L331.31 211.78V331.31H0V272.29Z" fill="%23E0E0E0" fill-opacity="0.5"/>%0A<path d="M66 118.39C84.4905 118.39 99.48 103.4 99.48 84.91C99.48 66.4195 84.4905 51.43 66 51.43C47.5095 51.43 32.52 66.4195 32.52 84.91C32.52 103.4 47.5095 118.39 66 118.39Z" fill="%23F5F5F5"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_4102_4121">%0A<rect width="331.31" height="331.31" fill="white"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';import{jsx as mo}from"react/jsx-runtime";var Sn=e=>mo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:mo("path",{fill:e.color??"currentColor",d:"M6 14c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 4 12c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 6 10c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 6 14m6 0c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 10 12c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 12 10c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 12 14m6 0c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 16 12c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 18 10c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 18 14"})}),uo=Sn;import{forwardRef as $n}from"react";import wn from"styled-components";import Pn from"styled-components";var Z=Pn(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.embedded.default};
    color: ${({theme:e})=>e.buttons.embedded.content};
    border-color: ${({theme:e})=>e.buttons.embedded.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.embedded.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.embedded.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.embedded.default};
        color: ${({theme:e})=>e.buttons.embedded.disabledContent};
    }
`;import{jsx as go}from"react/jsx-runtime";var Bn=wn(Z).attrs({$variant:"small"})`
    ${N}
    /* content */
    color: ${({$color:e,theme:o})=>e??o.action};
`,P=$n(({icon:e,color:o,...r},a)=>go(Bn,{$color:o,...r,ref:a,children:go(e,{color:"currentcolor"})}));P.displayName="EmbeddedIconButton";import{forwardRef as xo}from"react";import*as M from"@radix-ui/react-dropdown-menu";import yo from"styled-components";import{css as bo}from"styled-components";var ne="0px 2px 4px 0px",fo="-2px 0px 4px 0px",ho="0px 2px 3px 0px";var Ee=bo`
    /* reset */
    outline: none;
    user-select: none;

    /* layout */
    min-width: 168px; // magic number from design
    padding-block: ${n[25]};
    margin-top: ${n[25]};
    margin-inline: ${n[25]};

    /* content */
    ${h}

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    border: 1px solid ${({theme:e})=>e.stroke.light};
    border-radius: ${d.small};
    box-shadow: ${({theme:e})=>`${ne} ${e.menu.shadow}`};
`,ae=bo`
    /* reset */
    outline: none;
    cursor: pointer;
    box-sizing: border-box;

    /* layout */
    padding-inline: ${s.componentInlinePadding};
    height: ${$.large};
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${s.innerGap};

    /* content */
    color: ${({$selected:e,theme:o})=>e?o.accent:o.menu.itemContent};

    /* appearance */
    background-color: ${({theme:e})=>e.menu.itemFill};

    &:focus-visible,
    &:hover:not([data-disabled]) {
        background-color: ${({theme:e})=>e.menu.itemHoverFill};
    }

    &:active:not([data-disabled]) {
        background-color: ${({theme:e})=>e.menu.itemPressedFill};
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.menu.itemDisabledContent};
        cursor: not-allowed;
    }
`;import{jsx as yt,jsxs as kn}from"react/jsx-runtime";var Tn=yo(M.Content)`
    ${Ee}
`,Cn=yo(M.Item)`
    ${ae}
`,vo=xo(({children:e,icon:o,...r},a)=>kn(Cn,{...r,ref:a,children:[o&&yt(o,{color:"currentColor"}),e]}));vo.displayName="DropdownMenuItem";var So=xo(({children:e,...o},r)=>yt(M.Portal,{children:yt(Tn,{...o,ref:r,children:e})}));So.displayName="DropdownMenuContent";var R={Root:M.Root,Trigger:M.Trigger,Content:So,Item:vo};import{jsx as X,jsxs as He}from"react/jsx-runtime";var Rn=L.figure`
    /* reset */
    margin: 0;
`,In=L.div`
    /* reset */
    user-select: none;
    position: relative;

    /* content */
    color: ${({theme:e})=>e.thumbnail.contentOnDark};

    /* layout */
    min-width: 160px;
    min-height: 160px;
    aspect-ratio: 1;

    /* appearance */
    border-radius: ${d.medium};
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.5) 0%,
            rgba(0, 0, 0, 0.1) 25%,
            rgba(0, 0, 0, 0) 37.5%,
            rgba(0, 0, 0, 0) 62.5%,
            rgba(0, 0, 0, 0.1) 75%,
            rgba(0, 0, 0, 0.5) 100%
        );
    }
`,vt=L.img`
    /* appearance */
    width: 100%;
    height: 100%;
    object-fit: cover;
`,An=L(p.Subheader)`
    font-size: 1rem;
`,Dn=L.figcaption`
    /* layout */
    margin-top: ${n[25]};
    margin-left: ${n[25]};
`,Mn=L.div.attrs({"aria-hidden":!0,role:"presentation"})`
    /* layout */
    position: absolute;
    bottom: ${n[50]};
    left: ${n[50]};
`,En=L.div.attrs({"aria-hidden":!0,role:"presentation"})`
    /* layout */
    position: absolute;
    bottom: ${n[50]};
    right: ${n[50]};
`,Hn=L.div.attrs({"aria-hidden":!0,role:"presentation"})`
    /* layout */
    position: absolute;
    top: ${n[50]};
    right: ${n[50]};
`,Se=({title:e,subtitle:o,coverPhoto:r,children:a})=>He(Rn,{children:[He(In,{children:[r?X(vt,{as:"object","aria-label":e,type:"image/jpg",data:r,children:X(vt,{src:po,alt:e})}):X(vt,{src:co,alt:e}),a]}),He(Dn,{children:[X(An,{children:e}),X(p.Paragraph,{children:o})]})]}),Gn=L(P)`
    /* content */
    color: ${({theme:e})=>e.thumbnail.contentOnDark};
`,Fn=({children:e,...o})=>He(R.Root,{children:[X(R.Trigger,{asChild:!0,children:X(Gn,{...o,"aria-label":"Menu",icon:uo})}),X(R.Content,{align:"end",children:e})]});Se.BottomLeft=Mn;Se.BottomRight=En;Se.TopRight=Hn;Se.MenuButton=Fn;import{forwardRef as Ln}from"react";import{jsx as Po}from"react/jsx-runtime";var Vn=e=>Po("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Po("path",{fill:e.color??"currentColor",d:"M6.4 19H8c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.967.967 0 0 1 8 21H4a.967.967 0 0 1-.712-.288A.968.968 0 0 1 3 20v-4c0-.283.096-.52.288-.713A.967.967 0 0 1 4 15c.283 0 .52.096.713.287.191.192.287.43.287.713v1.6l2.4-2.4a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7zM19 6.4l-2.4 2.4a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7L17.6 5H16a.968.968 0 0 1-.713-.287A.967.967 0 0 1 15 4c0-.283.096-.52.287-.712A.968.968 0 0 1 16 3h4c.283 0 .52.096.712.288.192.191.288.429.288.712v4c0 .283-.096.52-.288.713A.968.968 0 0 1 20 9a.968.968 0 0 1-.712-.287A.967.967 0 0 1 19 8z"})}),$o=Vn;import{jsx as zn}from"react/jsx-runtime";var wo=Ln(({...e},o)=>zn(P,{icon:$o,color:"white",...e,ref:o}));wo.displayName="ThumbnailExpandPreviewButton";import Ge from"styled-components";import{jsx as Bo,jsxs as _n}from"react/jsx-runtime";var To=Ge.figure`
    cursor: pointer;

    /* reset */
    user-select: none;
    position: relative;

    /* content */
    color: ${({theme:e})=>e.thumbnail.contentOnDark};

    /* layout */
    width: 102px;
    height: 142px;
    aspect-ratio: 1;

    margin: ${n[25]};

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border-radius: ${d.medium};
        background: linear-gradient(
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.27) 100%
        );
    }
`,Wn=Ge(To)`
    margin: 0px;

    padding: 1px;
    border-radius: ${d.mediumLarge};
    border: 3px solid ${({theme:e})=>e.thumbnail.collectionOutline};

    &::before {
        left: 1px;
        top: 1px;
        right: 1px;
        bottom: 1px;
    }
`,Un=Ge.figcaption`
    /* layout */
    position: absolute;
    bottom: ${n[50]};
    left: 50%;
    transform: translate(-50%, 0);
    width: 95%; /* Limit caption width to be 12 characters per line */

    font-weight: 700;
    text-align: center;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
`,On=Ge.img`
    /* appearance */
    width: 100%;
    height: 100%;
    border-radius: ${d.medium};

    object-fit: cover;
`,Nn=({coverPhoto:e,title:o,hasSeen:r})=>_n(r?To:Wn,{children:[Bo(On,{as:"object",type:"image/jpg","aria-label":o,data:e}),Bo(Un,{children:o})]});import*as Fe from"@radix-ui/react-toggle-group";import*as Ve from"@radix-ui/react-toggle";import Pe,{css as Ro}from"styled-components";import{jsx as Co}from"react/jsx-runtime";var Zn=e=>Co("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Co("path",{fill:e.color??"currentColor",d:"m12 13.4-4.9 4.9a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7l4.9-4.9-4.9-4.9a.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275l4.9 4.9 4.9-4.9a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L13.4 12l4.9 4.9a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.949.949 0 0 1-.7-.275z"})}),K=Zn;import{jsx as ie,jsxs as ko}from"react/jsx-runtime";var Io=Ro`
    /* reset */
    ${y}

    /* layout */
    ${ee}
    margin: 0;
    height: ${$.medium};
    gap: ${n[50]};

    /* content */
    color: ${({theme:e})=>e.action};

    /* appearance */
    ${ye}
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.round};

    svg {
        margin: -${n[25]};
        fill: ${({theme:e})=>e.iconDefault};
    }

    &:focus-visible {
        outline: ${({theme:e})=>e.focus} solid 2px;
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.disabledContent};
        cursor: not-allowed;

        svg {
            fill: ${({theme:e})=>e.disabledContent};
        }
    }
`,Xn=Pe(Fe.Root)`
    /* layout */
    display: flex;
    align-items: center;
    gap: ${s.innerGap};
`,St=Pe(Ve.Root)`
    ${Io}

    /* layout */
    padding-inline: ${n[100]};

    /* appearance */
    border-color: ${({theme:e})=>e.stroke.light};

    &:hover:not([data-disabled]) {
        background-color: ${({theme:e})=>e.greyHover};
    }

    &:active:not([data-disabled]) {
        background-color: ${({theme:e})=>e.emptyStateCard};
    }

    svg.context-icon {
        fill: ${({theme:e,$defaultIconColor:o})=>o??e.iconDefault};
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.disabledContent};
        cursor: not-allowed;

        svg {
            fill: ${({theme:e})=>e.disabledContent};
        }
    }
`,Pt=Ro`
    ${Io}

    /* layout */
    padding-inline: 0;
    width: fit-content;

    /* content */
    color: ${({theme:e})=>e.accent};

    /* appearance */
    background-color: ${({theme:e})=>e.emptyStateCard};
    border-color: ${({theme:e})=>e.accent};

    svg.context-icon {
        fill: ${({theme:e})=>e.accent};
    }
`,Kn=Pe.section`
    ${Pt}

    /* reset */
    cursor: default;

    /* layout */
    gap: ${n[50]};
    padding-left: ${n[100]};

    svg {
        margin: -${n[25]};
        fill: ${({theme:e})=>e.iconDefault};
    }
`,$t=Pe(Ve.Root)`
    /* reset */
    ${y}

    /* layout */
    ${N}
    padding-inline: ${n[25]} ${n[100]};
    height: 100%;

    /* content */
    fill: ${({theme:e})=>e.action};

    /* appearance */
    background-color: transparent;
    border-radius: 0 99px 99px 0;

    svg {
        margin: -${n[25]};
    }

    &:hover {
        background-color: ${({theme:e})=>e.greyHover};
    }

    &:active {
        background-color: ${({theme:e})=>e.greyPress};
    }

    &:focus-visible {
        outline: ${({theme:e})=>e.focus} solid 2px;
    }
`,le=Pe.span`
    line-height: 1em;
    white-space: nowrap;
`,qn=({as:e,icon:o,defaultIconColor:r,onPress:a,onDelete:i,children:l,pressed:g,...u})=>{let x=e==="item"?Ve.Root:Fe.Item;return g?ko(Kn,{role:"radio","aria-checked":!0,children:[ie(o,{className:"context-icon",color:"inherit"}),ie(le,{children:l}),ie($t,{...u,as:x,onClick:i,"data-value":u.value,$variant:"medium",children:ie(K,{className:"close-icon",color:"inherit"})})]}):ko(St,{...u,as:x,onClick:()=>{a(u.value)},"data-value":u.value,$defaultIconColor:r,children:[ie(o,{className:"context-icon",color:"inherit"}),ie(le,{children:l})]})};import{useMemo as Qn,useState as Yn}from"react";import*as Do from"@radix-ui/react-toggle-group";import*as Mo from"@radix-ui/react-toggle";import Eo from"styled-components";import{jsx as Ao}from"react/jsx-runtime";var Jn=e=>Ao("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Ao("path",{fill:e.color??"currentColor",d:"M11.475 14.475 7.85 10.85a.47.47 0 0 1-.15-.35c0-.133.046-.25.138-.35.091-.1.212-.15.362-.15h7.6c.15 0 .271.05.363.15.091.1.137.217.137.35 0 .033-.05.15-.15.35l-3.625 3.625a.762.762 0 0 1-.25.175.735.735 0 0 1-.275.05.735.735 0 0 1-.275-.05.762.762 0 0 1-.25-.175"})}),wt=Jn;import{jsx as w,jsxs as Le}from"react/jsx-runtime";var jn=Eo.section`
    ${Pt}
`,ea=Eo.button`
    /* reset */
    ${y}

    /* content */
    ${h}

    /* layout */
    ${ee}
    gap: ${n[50]};
    padding-inline: ${n[100]} ${n[25]};
    height: 100%;

    svg {
        margin: -${n[25]};
        fill: ${({theme:e})=>e.iconDefault};
    }
`,ta=({as:e,defaultIconColor:o,disabled:r,icon:a,options:i,pressed:l,onDelete:g,onSelect:u,children:x,...k})=>{let[oe,re]=Yn(!1),lt=V=>{re(!1),u(V)},st=V=>{re(V)},dt=Qn(()=>i.find(V=>V.value===k.value),[i,k.value]),Re=e==="item"?Mo.Root:Do.Item;return Le(R.Root,{open:oe,onOpenChange:st,children:[l?Le(jn,{role:"radio","aria-checked":!0,children:[w(R.Trigger,{asChild:!0,children:Le(ea,{onClick:()=>{re(!0)},children:[w(a,{className:"context-icon",color:"inherit"}),w(le,{children:dt?.label}),w(wt,{className:"expand-icon",color:"inherit"})]})}),w($t,{...k,as:Re,onClick:g,"data-value":k.value,$variant:"medium",children:w(K,{className:"close-icon",color:"inherit"})})]}):w(R.Trigger,{asChild:!0,disabled:r,children:Le(St,{...k,as:Re,onClick:()=>{re(!0)},"data-value":k.value,$defaultIconColor:o,children:[w(a,{className:"context-icon",color:"inherit"}),w(le,{children:x}),w(wt,{className:"expand-icon",color:"inherit"})]})}),w(R.Content,{align:"start",children:i.map(V=>{let{value:fe,label:Kt,isDisabled:qt}=V,Jt=l&&k.value===fe;return w(R.Item,{id:fe,onSelect:ct=>{lt(ct.target.id)},$selected:Jt,disabled:qt,children:Kt},fe)})})]})};import oa from"styled-components";import{jsx as aa}from"react/jsx-runtime";var ra=oa(v)`
    /* reset */
    padding: 0;
    border: none;
    height: auto;

    /* layout */
    display: flex;
    gap: ${n[25]};

    /* content */
    color: ${({theme:e})=>e.buttons.link.default};
    text-decoration: underline;
    text-underline-offset: ${n[25]};

    /* appearance */
    &[data-visited='true'] {
        color: ${({theme:e})=>e.buttons.link.used};
    }
    &[data-hovered] {
        color: ${({theme:e})=>e.buttons.link.hover};
    }
    &[data-pressed] {
        color: ${({theme:e})=>e.buttons.link.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        color: ${({theme:e})=>e.buttons.link.disabled};
    }
`,na=({isVisited:e,children:o,...r})=>aa(ra,{...r,"data-visited":e,$variant:"medium",children:o});import We from"styled-components";import ia from"styled-components";var ze=ia(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.primaryDestructive.defaultBackgroud};
    color: ${({theme:e})=>e.buttons.primaryDestructive.defaultContent};
    border-color: ${({theme:e})=>e.buttons.primaryDestructive.defaultBackgroud};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.primaryDestructive.hoverBackground};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.primaryDestructive.pressedBackground};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.primaryDestructive.disabledBackground};
        border-color: ${({theme:e})=>e.buttons.primaryDestructive.disabledBackground};
        color: ${({theme:e})=>e.buttons.primaryDestructive.disabledContent};
    }
`;import la from"styled-components";var q=la(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.primary.default};
    color: ${({theme:e})=>e.buttons.primary.content};
    border-color: ${({theme:e})=>e.buttons.primary.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.primary.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.primary.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.primary.disabled};
        color: ${({theme:e})=>e.buttons.primary.disabledContent};
        border-color: ${({theme:e})=>e.buttons.primary.disabled};
    }
`;import sa from"styled-components";var E=sa(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.secondary.default};
    color: ${({theme:e})=>e.accent};
    border-color: ${({theme:e})=>e.accent};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.secondary.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.secondary.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        border-color: ${({theme:e})=>e.buttons.secondary.disabledContent};
        background-color: ${({theme:e})=>e.buttons.secondary.default};
        color: ${({theme:e})=>e.buttons.secondary.disabledContent};
    }
`;import da from"styled-components";var te=da(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.teritary.default};
    color: ${({theme:e})=>e.buttons.teritary.content};
    border-color: ${({theme:e})=>e.buttons.teritary.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.teritary.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.teritary.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.teritary.disabled};
        border-color: ${({theme:e})=>e.buttons.teritary.disabled};
        color: ${({theme:e})=>e.buttons.teritary.disabledContent};
    }
`;var ca=We(q).attrs({$variant:"large",$fluid:!1})``,pa=We(E).attrs({$variant:"large",$fluid:!1})``,ma=We(ze).attrs({$variant:"large",$fluid:!1})``,ua=We(te).attrs({$variant:"large",$fluid:!0})``;import{forwardRef as ga}from"react";import fa from"styled-components";var m={small:"600px",medium:"900px",large:"1200px"};import{jsx as Ho}from"react/jsx-runtime";var ha=fa(Z).attrs({$variant:"small"})`
    @media (max-width: ${m.small}) {
        ${N}

        .button-text {
            display: none;
        }
    }
`,Go=ga(({text:e,...o},r)=>Ho(ha,{...o,ref:r,children:Ho("span",{className:"button-text",children:e})}));Go.displayName="NavBarButton";import ba from"styled-components";var xa=ba(P)`
    color: ${({theme:e})=>e.buttons.embedded.contentOnDark};

    /* variants */
    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.embedded.hoverOnDark};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.embedded.hoverOnDark};
    }
    &[data-disabled] {
        cursor: not-allowed;
        color: ${({theme:e})=>e.buttons.embedded.disabledContent};
    }
`;import Vo from"styled-components";import*as B from"@radix-ui/react-dialog";import{jsx as Fo,jsxs as $a}from"react/jsx-runtime";var ya=Vo(B.Overlay)`
    /* layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    /* appearance */
    background-color: ${({theme:e})=>e.backdrop};
`,va=Vo(B.Content)`
    /* reset */
    user-select: none;

    /* layout */
    position: fixed;
    bottom: 0;
    left: 0;
    height: auto;
    max-height: 60vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.large} ${d.large} 0 0;
    outline: none;
`,Sa=B.Root,Pa=B.Trigger,Lo=B.Title,zo=({children:e})=>$a(B.Portal,{children:[Fo(ya,{}),Fo(va,{children:e})]});import*as Ue from"@radix-ui/react-checkbox";import Oo from"styled-components";import{jsx as Wo}from"react/jsx-runtime";var wa=e=>Wo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Wo("path",{fill:e.color??"currentColor",d:"m10.6 13.4-2.15-2.15a.948.948 0 0 0-.7-.275.948.948 0 0 0-.7.275.948.948 0 0 0-.275.7c0 .283.092.517.275.7L9.9 15.5c.2.2.433.3.7.3.267 0 .5-.1.7-.3l5.65-5.65a.948.948 0 0 0 .275-.7.948.948 0 0 0-.275-.7.948.948 0 0 0-.7-.275.948.948 0 0 0-.7.275zM5 21c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.804 3.98 21 4.45 21 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21z"})}),Uo=wa;import{jsx as Bt,jsxs as ka}from"react/jsx-runtime";var Ba=Oo.label`
    /* reset */
    cursor: pointer;
    user-select: none;

    /* content */
    ${h}

    /* layout */
    display: flex;
    align-items: center;
    gap: 0.5em;

    color: ${({theme:e})=>e.checkbox.defaultText};

    /* appearance */
    &:has([data-disabled]) {
        cursor: not-allowed;
        color: ${({theme:e})=>e.checkbox.disabled};
    }

    &:hover:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.checkbox.hover};
    }

    &:active:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.checkbox.pressed};
    }
`,Ta=Oo(Ue.Root)`
    /* reset */
    ${y}
    position: relative;

    /* layout */
    width: 1.5rem;
    height: 1.5rem;
    box-sizing: border-box;

    /* appearance */
    color: ${({theme:e})=>e.checkbox.defaultFill};
    &[data-disabled] {
        cursor: not-allowed;
        color: ${({theme:e})=>e.checkbox.disabled};
    }

    &:hover:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.checkbox.hover};
    }

    // adding a symbol for unchecked state
    &:after {
        /* reset */
        content: '';
        box-sizing: border-box;

        /* layout */
        top: 0.25rem;
        left: 0.25rem;
        position: absolute;
        width: 1rem;
        height: 1rem;

        /* appearance */
        border-radius: 1px;
        outline-width: 2px;
        // we need one pixel on either side of the outline
        outline-offset: -1px;
        outline-style: solid;
        outline-color: inherit;
    }
`,Ca=({name:e,children:o,...r})=>ka(Ba,{htmlFor:e,children:[Bt(Ta,{...r,name:e,children:Bt(Ue.Indicator,{children:Bt(Uo,{color:"currentColor"})})}),o]});import No from"styled-components";import*as Oe from"@radix-ui/react-toggle-group";import{jsx as Tt,jsxs as _o}from"react/jsx-runtime";var Ra=No(Lo)`
    /* reset */
    cursor: default;
    font-weight: normal;
    font-style: normal;
    font-size: 1rem;
    margin: 0;

    /* content */
    ${be}
    color: ${({theme:e})=>e.notes};

    /* layout */
    height: ${$.large};
    display: flex;
    align-items: center;
    padding-inline: ${s.horizontalComponentGap};
`,Ia=No(Oe.Item)`
    /* reset */
    ${ae}
    border: none;

    /* content */
    ${h}
    color: ${({theme:e})=>e.secondaryText};
    &[data-state='on'] {
        color: ${({theme:e})=>e.accent};
    }
`,Aa=({title:e,children:o,...r})=>_o(zo,{children:[Tt(Ra,{children:e}),Tt(Oe.Root,{type:"single",...r,children:o})]}),Da=({icon:e,children:o,...r})=>_o(Ia,{...r,children:[Tt(e,{color:"currentcolor"}),o]});import{forwardRef as Zo}from"react";import*as H from"@radix-ui/react-context-menu";import Xo from"styled-components";import{jsx as Ct,jsxs as Ga}from"react/jsx-runtime";var Ma=Xo(H.Content)`
    ${Ee}
`,Ea=Xo(H.Item)`
    ${ae}
`,Ko=Zo(({children:e,icon:o,...r},a)=>Ga(Ea,{...r,ref:a,children:[o&&Ct(o,{}),e]}));Ko.displayName="ContextMenuItem";var qo=Zo(({children:e,...o},r)=>Ct(H.Portal,{children:Ct(Ma,{...o,ref:r,children:e})}));qo.displayName="ContextMenuContent";var Ha={Root:H.Root,Trigger:H.Trigger,Content:qo,Item:Ko};import lr from"styled-components";import{jsx as Jo}from"react/jsx-runtime";var Fa=e=>Jo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Jo("path",{fill:e.color??"currentColor",d:"m9.55 15.15 8.475-8.475c.2-.2.438-.3.713-.3.274 0 .512.1.712.3.2.2.3.438.3.713 0 .274-.1.512-.3.712l-9.2 9.2c-.2.2-.433.3-.7.3a.96.96 0 0 1-.7-.3L4.55 13a.93.93 0 0 1-.288-.713 1.02 1.02 0 0 1 .313-.712c.2-.2.437-.3.712-.3.275 0 .513.1.713.3l3.55 3.575"})}),Ne=Fa;import{jsx as Qo}from"react/jsx-runtime";var Va=e=>Qo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Qo("path",{fill:"#9E9E9E",d:"M22 6v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412M4 8h16V6H4zm0 4v6h16v-6z"})}),kt=Va;import{jsx as $e,jsxs as za}from"react/jsx-runtime";var La=e=>za("svg",{xmlns:"http://www.w3.org/2000/svg",width:96,height:96,fill:e.color??"currentColor",viewBox:"0 0 96 96",...e,children:[$e("g",{clipPath:"url(#a)",children:$e("path",{fill:e.color??"currentColor",d:"M22 70c-6.133 0-11.333-2.133-15.6-6.4C2.133 59.333 0 54.133 0 48c0-6.133 2.133-11.333 6.4-15.6C10.667 28.133 15.867 26 22 26c2.467 0 4.833.433 7.1 1.3 2.267.867 4.3 2.1 6.1 3.7l6.8 6.2-6 5.4-6.2-5.6a12.443 12.443 0 0 0-3.6-2.2A11.205 11.205 0 0 0 22 34c-3.867 0-7.167 1.367-9.9 4.1C9.367 40.833 8 44.133 8 48s1.367 7.167 4.1 9.9c2.733 2.733 6.033 4.1 9.9 4.1 1.467 0 2.867-.267 4.2-.8a12.443 12.443 0 0 0 3.6-2.2l31-28c1.8-1.6 3.833-2.833 6.1-3.7A19.711 19.711 0 0 1 74 26c6.133 0 11.333 2.133 15.6 6.4C93.867 36.667 96 41.867 96 48c0 6.133-2.133 11.333-6.4 15.6C85.333 67.867 80.133 70 74 70c-2.467 0-4.833-.433-7.1-1.3-2.267-.867-4.3-2.1-6.1-3.7L54 58.8l6-5.4 6.2 5.6a12.443 12.443 0 0 0 3.6 2.2c1.333.533 2.733.8 4.2.8 3.867 0 7.167-1.367 9.9-4.1 2.733-2.733 4.1-6.033 4.1-9.9s-1.367-7.167-4.1-9.9C81.167 35.367 77.867 34 74 34c-1.467 0-2.867.267-4.2.8a12.443 12.443 0 0 0-3.6 2.2l-31 28a19.687 19.687 0 0 1-6.1 3.7A19.711 19.711 0 0 1 22 70"})}),$e("defs",{children:$e("clipPath",{id:"a",children:$e("path",{fill:"#fff",d:"M0 0h96v96H0z"})})})]}),Rt=La;import{jsx as we,jsxs as Ua}from"react/jsx-runtime";var Wa=e=>Ua("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:[we("path",{fill:e.color??"currentColor",d:"M22.72 4H1.28C.573 4 0 4.608 0 5.359V18.64C0 19.391.573 20 1.28 20h21.44c.707 0 1.28-.608 1.28-1.359V5.36C24 4.609 23.427 4 22.72 4"}),we("path",{fill:"#fff",d:"M7.076 18.106v-.815c0-.313-.185-.517-.49-.517a.52.52 0 0 0-.45.23.458.458 0 0 0-.425-.23.446.446 0 0 0-.384.19V16.8h-.251v1.305h.252v-.747c0-.23.132-.34.318-.34.185 0 .291.123.291.34v.748h.252v-.748c0-.23.132-.34.318-.34s.292.123.292.34v.748h.277m4.135-1.291h-.464v-.394h-.25v.394h-.266v.23h.265v.612c0 .3.106.476.424.476a.727.727 0 0 0 .344-.095l-.08-.23a.428.428 0 0 1-.238.068c-.133 0-.199-.081-.199-.217v-.625h.464v-.219m2.36-.041a.394.394 0 0 0-.345.19V16.8h-.252v1.305h.252v-.733c0-.217.106-.353.278-.353a.756.756 0 0 1 .172.027l.08-.245a.876.876 0 0 0-.186-.027m-3.566.136c-.132-.095-.318-.136-.517-.136-.318 0-.516.15-.516.408 0 .218.146.34.424.38l.132.014c.146.027.239.082.239.15 0 .095-.106.164-.305.164a.687.687 0 0 1-.424-.136l-.133.204c.186.136.411.164.544.164.372 0 .57-.177.57-.421 0-.23-.16-.34-.437-.381l-.133-.014c-.119-.013-.224-.054-.224-.136 0-.095.106-.164.252-.164.16 0 .318.068.398.109l.13-.205m3.844.544c0 .393.252.68.662.68.186 0 .319-.041.451-.15l-.132-.204a.528.528 0 0 1-.332.122c-.224 0-.397-.176-.397-.434 0-.259.171-.434.397-.434.121.001.238.044.332.122l.132-.203a.65.65 0 0 0-.45-.15c-.398-.027-.663.258-.663.652v-.001m-1.776-.68c-.371 0-.623.272-.623.68 0 .408.265.68.649.68a.797.797 0 0 0 .517-.177l-.133-.19a.624.624 0 0 1-.37.135.375.375 0 0 1-.385-.34h.941v-.108c0-.408-.239-.68-.596-.68m-.013.245c.185 0 .318.122.33.326h-.688c.04-.19.16-.326.358-.326M8.627 16.8h-.252v.164a.48.48 0 0 0-.41-.19c-.358 0-.624.286-.624.68 0 .394.265.68.623.68a.482.482 0 0 0 .411-.191v.164h.252v-1.307m-1.02.653c0-.245.145-.435.397-.435.239 0 .384.19.384.435 0 .258-.16.435-.384.435-.252.013-.397-.19-.397-.435m9.794-.68a.394.394 0 0 0-.344.19V16.8h-.252v1.305h.251v-.733c0-.217.106-.353.278-.353a.756.756 0 0 1 .173.027l.08-.245a.874.874 0 0 0-.186-.027m-.98.027h-.252v.164a.48.48 0 0 0-.411-.19c-.358 0-.623.286-.623.68 0 .394.264.68.623.68a.482.482 0 0 0 .41-.191v.164h.252v-1.307m-1.021.653c0-.245.146-.435.398-.435.238 0 .384.19.384.435 0 .258-.16.435-.384.435-.252.013-.398-.19-.398-.435m3.578-1.17h-.252v.68a.48.48 0 0 0-.41-.19c-.358 0-.623.285-.623.68 0 .394.265.68.623.68a.482.482 0 0 0 .41-.19v.163h.252v-1.822m-1.02 1.17c0-.245.146-.435.398-.435.238 0 .384.19.384.435 0 .258-.16.435-.384.435-.253.013-.398-.19-.398-.435"}),we("path",{fill:"#FF5F00",d:"M14.313 6.905h-4.6V14.6h4.6V6.905"}),we("path",{fill:"#EB001B",d:"M10.178 10.752c0-1.5.669-2.916 1.815-3.847a4.686 4.686 0 0 0-6.454.527 4.986 4.986 0 0 0 0 6.64 4.686 4.686 0 0 0 6.454.527 4.954 4.954 0 0 1-1.815-3.847"}),we("path",{fill:"#F79E1B",d:"M19.72 10.752c.002 1.872-1.04 3.581-2.681 4.4a4.67 4.67 0 0 1-5.03-.553 4.952 4.952 0 0 0 1.815-3.847c0-1.5-.669-2.917-1.815-3.847a4.67 4.67 0 0 1 5.03-.553c1.641.82 2.683 2.528 2.682 4.4"})]}),Yo=Wa;import{jsx as jo}from"react/jsx-runtime";var Oa=e=>jo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:jo("path",{fill:e.color??"currentColor",d:"M5 19h1.425L16.2 9.225 14.775 7.8 5 17.575zm-1 2a.967.967 0 0 1-.712-.288A.968.968 0 0 1 3 20v-2.425a1.975 1.975 0 0 1 .575-1.4L16.2 3.575c.2-.183.42-.325.663-.425.241-.1.495-.15.762-.15s.525.05.775.15c.25.1.467.25.65.45L20.425 5c.2.183.346.4.438.65a2.165 2.165 0 0 1 0 1.512 1.874 1.874 0 0 1-.438.663l-12.6 12.6a1.975 1.975 0 0 1-1.4.575zM15.475 8.525l-.7-.725L16.2 9.225z"})}),er=Oa;import{jsx as tr}from"react/jsx-runtime";var Na=e=>tr("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:tr("path",{fill:e.color??"currentColor",d:"M15.5 11c.417 0 .77-.146 1.063-.437.291-.292.437-.646.437-1.063 0-.417-.146-.77-.437-1.062A1.447 1.447 0 0 0 15.5 8c-.417 0-.77.146-1.062.438A1.446 1.446 0 0 0 14 9.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437m-7 0c.417 0 .77-.146 1.063-.437.291-.292.437-.646.437-1.063 0-.417-.146-.77-.437-1.062A1.447 1.447 0 0 0 8.5 8c-.417 0-.77.146-1.062.438A1.447 1.447 0 0 0 7 9.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437m3.5 2.5c-1.133 0-2.162.32-3.088.963A5.485 5.485 0 0 0 6.9 17h1.65a4.099 4.099 0 0 1 1.462-1.463A3.846 3.846 0 0 1 12 15c.717 0 1.38.18 1.988.537A4.1 4.1 0 0 1 15.45 17h1.65a5.485 5.485 0 0 0-2.013-2.537A5.294 5.294 0 0 0 12 13.5m0 8.5a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22m0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20"})}),or=Na;import{jsx as It,jsxs as Za}from"react/jsx-runtime";var _a=e=>Za("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:[It("path",{fill:"#0E4595",d:"M1.23 4h21.54c.679 0 1.23.573 1.23 1.28v13.44c0 .707-.551 1.28-1.23 1.28H1.23C.552 20 0 19.427 0 18.72V5.28C0 4.573.551 4 1.23 4"}),It("path",{fill:"#fff",d:"m9.022 15.128 1.026-6.177h1.642l-1.027 6.177H9.022m7.572-6.044a4.146 4.146 0 0 0-1.471-.26c-1.622 0-2.765.838-2.775 2.039-.01.888.816 1.383 1.439 1.678.639.303.853.496.85.767-.004.414-.51.603-.982.603-.657 0-1.006-.094-1.545-.324l-.212-.098-.23 1.383c.383.172 1.092.321 1.829.33 1.726 0 2.846-.83 2.859-2.111.006-.703-.432-1.238-1.379-1.679-.574-.286-.925-.477-.921-.766 0-.257.297-.531.94-.531.537-.009.926.111 1.229.236l.147.072.222-1.34m4.225-.134h-1.268c-.393 0-.688.11-.86.513l-2.438 5.661h1.724s.281-.761.345-.928l2.103.003c.049.216.2.925.2.925h1.523L20.819 8.95m-2.013 3.99c.136-.356.654-1.727.654-1.727-.01.016.135-.358.218-.59l.111.533.38 1.784h-1.363M7.628 8.95 6.02 13.164l-.17-.857c-.3-.987-1.232-2.056-2.275-2.591l1.47 5.403 1.737-.002L9.367 8.95h-1.74Z"}),It("path",{fill:"#F2AE14",d:"M4.52 8.827H1.874l-.02.129c2.059.511 3.422 1.747 3.987 3.232l-.575-2.84c-.1-.39-.388-.507-.744-.52"})]}),rr=_a;import{jsx as nr}from"react/jsx-runtime";var Xa=e=>nr("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:nr("path",{fill:e.color??"currentColor",d:"M2.725 21a.973.973 0 0 1-.85-.5 1.098 1.098 0 0 1-.137-.488.898.898 0 0 1 .137-.512l9.25-16c.1-.167.23-.292.387-.375.159-.083.321-.125.488-.125.167 0 .33.042.488.125a.983.983 0 0 1 .387.375l9.25 16c.1.167.146.337.137.512a1.096 1.096 0 0 1-.137.488.973.973 0 0 1-.85.5H2.725Zm1.725-2h15.1L12 6 4.45 19M12 18c.283 0 .52-.096.713-.288A.968.968 0 0 0 13 17a.968.968 0 0 0-.287-.712A.967.967 0 0 0 12 16a.968.968 0 0 0-.713.288A.968.968 0 0 0 11 17c0 .283.096.52.287.712.192.192.43.288.713.288m0-3c.283 0 .52-.096.713-.287A.968.968 0 0 0 13 14v-3a.968.968 0 0 0-.287-.713A.967.967 0 0 0 12 10a.968.968 0 0 0-.713.287A.968.968 0 0 0 11 11v3c0 .283.096.52.287.713.192.191.43.287.713.287"})}),ar=Xa;import se from"styled-components";var At=se(p.Paragraph).attrs({as:"section"})`
    display: flex;
    justify-content: space-between;
`,Ka=se(At)`
    justify-content: center;
`,ir=se.li`
    ${O}
`,Dt=se.ul`
    all: unset;
    display: flex;
    flex-direction: row;
    column-gap: 0.5rem;
    list-style: none;

    & > li::before {
        content: '•';
        margin-right: 0.5rem;
    }

    & > li:first-child::before {
        content: '';
        margin-right: 0;
    }
`,qa=se(Dt)`
    padding-left: ${s.horizontalComponentGap};

    column-gap: 1rem;
    text-align: center;

    & > li::before {
        margin-right: 1rem;
    }

    @media (max-width: ${m.small}) {
        column-gap: 1.5rem;

        & > li::before {
            content: none;
            margin-right: 0.5rem;
        }
    }
`,Ja=se.span`
    font-weight: 700;

    &:after {
        content: ' ';
    }

    @media (max-width: ${m.small}) {
        display: block;
        &:after {
            content: '';
        }
    }
`,Qa={Section:Ka,Descriptions:qa,CountSize:Ja};import Ya from"styled-components";import{jsx as ei,jsxs as ti}from"react/jsx-runtime";var Mt=Ya.div`
    height: 2rem;
    width: 100%;
    display: grid;
    place-content: center;
    border-radius: 100px;
    color: ${({theme:e})=>e.dataUsageBar.used};
    font-size: 6rem;

    // prettier wants to split the code in several lines, which causes conflicts with the styled components linter
    /* prettier-ignore */
    background: linear-gradient(
        to right,
        ${({theme:e})=>e.dataUsageBar.used} ${({$completePercent:e})=>e}%,
        ${({theme:e})=>e.dataUsageBar.total} ${({$completePercent:e})=>e}%
    );
`,ja=({value:e})=>ti(p.Paragraph,{as:"label",children:[e,"%",ei(Mt,{$completePercent:e,role:"progressbar","aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":e})]});import{jsx as _e,jsxs as Be}from"react/jsx-runtime";var oi=lr.div.attrs({role:"none"})`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`,ri=lr(p.Subheader)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.25rem;
`,ni=({used:e,max:o,usage:r,totalQuota:a,usageDescriptions:i})=>{let l=o===0||o===1/0?0:Math.min(e/o*100,100),[g,u]=r,[x,k]=a;return Be(oi,{children:[Be(ri,{as:"label",htmlFor:"data_usage_bar",children:[g," ",u]}),Be(Mt,{$completePercent:l!==0?Math.max(l,5):l,role:"meter","aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":l,id:"data_usage_bar",children:[o===0&&0,o===1/0&&_e(Rt,{})]}),Be(At,{children:[_e(Dt,{children:i.map(oe=>_e(ir,{children:oe},oe))}),Be(p.Paragraph,{children:[_e(p.Bold,{children:x})," ",k]})]})]})};import ai from"styled-components";import{jsx as sr,jsxs as si}from"react/jsx-runtime";var ii=ai.main`
    display: grid;
    place-content: center;
    justify-items: center;
    gap: 0.5rem;
    height: 100%;
`,li=({children:e})=>si(ii,{children:[sr(p.Subheader,{children:e}),sr(or,{width:48,height:48})]});import Et,{useTheme as di}from"styled-components";import{jsx as Ze,jsxs as gi}from"react/jsx-runtime";var ci=Et.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-flow: row;
    align-items: center;
    column-gap: ${n[75]};
    row-gap: ${n[25]};
`,pi=Et.dd`
    /* reset */
    margin: 0;

    /* layout */
    grid-column: 2;

    /* content */
    ${O}
`,mi=Et.dd`
    /* reset */
    margin: 0;

    /* layout */
    grid-column: 2;

    > *:not(:first-child)::before {
        content: '•';
        margin-inline: ${n[50]};
    }

    /* content */
    ${xe}
    color: ${({theme:e})=>e.secondaryText};
`,ui=({icon:e,mainText:o,subTexts:r=[]})=>{let a=di(),i=!!o;return gi(ci,{children:[Ze(e,{color:a.iconDefault}),i&&Ze(pi,{children:o}),Ze(mi,{children:r.map(l=>Ze("span",{children:l},l))})]})};import Ht from"styled-components";import{jsx as dr,jsxs as cr}from"react/jsx-runtime";var fi="360px",hi="56px",bi=Ht.aside`
    /* layout */
    width: ${fi};
    height: 100vh;
    display: flex;
    flex-direction: column;

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    box-shadow: ${fo} ${({theme:e})=>e.menu.shadow};

    // take the whole screen in mobile views
    @media (max-width: ${m.small}) {
        width: 100vw;
    }
`,xi=Ht.header`
    /* reset */
    box-sizing: border-box;

    /* layout */
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: ${hi};
    border-bottom: 1px solid ${({theme:e})=>e.stroke.light};
    padding-inline: ${n[100]} ${n[75]};
`,yi=Ht.dl`
    /* reset */
    margin: 0;

    /* layout */
    padding: ${n[150]} ${n[75]};
    overflow: auto;

    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${n[150]};
`,vi=({title:e,onClose:o,children:r,...a})=>cr(bi,{...a,children:[cr(xi,{children:[e,dr(P,{onPress:o,icon:K})]}),dr(yi,{children:r})]});import*as S from"@radix-ui/react-form";import de from"styled-components";import{forwardRef as Si}from"react";import{Fragment as Mi,jsx as Te,jsxs as pr}from"react/jsx-runtime";var Pi=de(S.Field)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;

    min-height: 96px; /* we want to pre-occupy the space for error message */
    @media (max-width: ${m.small}) {
        min-height: 84px;
    }
`,$i=de(S.Label)`
    padding-left: ${s.innerGap};

    font-weight: 700;
    ${xe}
    color: ${({theme:e})=>e.notes};

    &[data-invalid] {
        color: ${({theme:e})=>e.alert};
    }
`,wi=de.span`
    color: ${({theme:e})=>e.alert};
`,Bi=de.input`
    padding-left: ${s.innerGap};

    outline: none;
    box-sizing: border-box;
    border-radius: ${d.small};
    border: 1px solid ${({theme:e})=>e.stroke.light};

    ${be}
    line-height: ${$.large};
    width: 100%;

    ::placeholder {
        color: ${({theme:e})=>e.notes};
    }

    &:focus {
        border: 1px solid ${({theme:e})=>e.accent};
    }

    &[data-invalid] {
        border: 1px solid ${({theme:e})=>e.alert};
    }

    :-webkit-autofill {
        -webkit-background-clip: text;
    }
`,mr=de(S.Message)`
    padding-left: ${s.innerGap};

    ${xe}
    color: ${({theme:e})=>e.notes};
`,Ti=de(mr)`
    color: ${({theme:e})=>e.alert};
`,Ci=({name:e,label:o,required:r,children:a,...i})=>pr(Pi,{...i,name:e,children:[pr($i,{children:[o,r&&Te(wi,{children:" *"})]}),a]}),ki=({errorMatchers:e})=>Te(Mi,{children:e.map(([o,r])=>Te(Ti,{match:o,children:r},r))}),ur=Si(({...e},o)=>Te(S.Control,{asChild:!0,children:Te(Bi,{...e,ref:o})}));ur.displayName="InputField";var Ri=S.Root,Ii=S.Submit,Ai=S.ValidityState,Di={Root:Ri,Field:Ci,ValidityState:Ai,ErrorMessage:ki,HintMessage:mr,Input:ur,Submit:Ii};import Ke,{keyframes as Ei}from"styled-components";import{jsx as Xe,jsxs as zi}from"react/jsx-runtime";var Hi=Ei`
    0% {
        transform: scale(0);
        opacity: 0;
    }
    33% {
        transform: scale(0.44);
        opacity: 1;
    }
    100% {
        transform: scale(0.88);
        opacity: 0;
    }
`,Gi=Ke.div.attrs({"aria-hidden":!0})`
    /* reset */
    // we leverage font-size to have the circles scale
    font-size: ${({size:e})=>e}rem;

    /* layout */
    width: ${({size:e})=>e}rem;
    height: ${({size:e})=>e}rem;
    position: relative;
`,gr=Ke.div`
    /* reset */
    box-sizing: border-box;

    /* layout */
    position: absolute;
    width: 100%;
    height: 100%;

    /* appearance */
    opacity: 0;
    border-radius: 50%;
    border: 0.125em solid ${({theme:e})=>e.accent};
    animation: ${Hi} 1.3s ease-out infinite;
`,Fi=Ke(gr)`
    /* appearance */
    border: 0.125em solid ${({theme:e})=>e.accent};
    animation-delay: 0.65s;
`,Vi=Ke.section`
    display: grid;
    place-content: center;
    height: 100%;
`,fr=({size:e=1.5})=>zi(Gi,{size:e,children:[Xe(gr,{}),Xe(Fi,{})]}),Li=()=>Xe(Vi,{children:Xe(fr,{size:4})});import Wi from"styled-components";var Ui=Wi.section`
    width: 640px;
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.small};
    box-sizing: border-box;
    padding: 1rem;
    padding-bottom: 2rem;

    margin-top: 2rem;
    height: fit-content;

    @media (max-width: ${m.small}) {
        /* layout */
        margin: 1rem;
    }
`;import Oi from"styled-components";var Ni=Oi.section`
    width: 310px;
    height: 134px;

    padding: ${n[50]} 0px;

    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.medium};
    box-shadow: ${({theme:e})=>`${ne} ${e.menu.shadow}`};

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: center;
    color: ${({theme:e})=>e.accent};

    @media (max-width: ${m.small}) {
        width: 186px;
        height: 144px;
    }
`;import T,{css as _i}from"styled-components";import*as I from"@radix-ui/react-dialog";import{Fragment as ll,jsx as z,jsxs as qe}from"react/jsx-runtime";var Zi=T(I.Overlay)`
    /* layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    /* appearance */
    background-color: ${({theme:e})=>e.backdrop};
`,Xi=T(I.Content)`
    /* reset */
    box-sizing: border-box;

    /* layout */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: ${({$flowPrompt:e})=>e?"640px":"512px"};
    max-height: 96%;
    padding: ${n[200]};
    display: flex;
    flex-direction: column;
    gap: ${n[200]};

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.small};
    outline: none;

    @media (max-width: ${m.small}) {
        /* layout */
        // in small screens we leave 1rem on each side
        width: calc(100% - ${n[200]});
    }
`,Ki=T.header`
    /* layout */
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`,qi=T.section`
    display: flex;
    gap: ${s.innerGap};
    align-items: center;
`,hr=T.form`
    display: grid;
    gap: ${n[200]};
    overflow-y: auto;
`,Ji=T.section`
    /* layout */
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: ${s.horizontalComponentGap};

    @media (max-width: ${m.small}) {
        /* layout */
        flex-direction: column-reverse;
    }
`,br=I.Root,xr=I.Trigger,yr=({title:e,icon:o,flowPrompt:r=!1,preventCloseOnClickOutside:a=!1,hideCloseButton:i=!1,children:l,...g})=>qe(ll,{children:[z(Zi,{}),qe(Xi,{...g,$flowPrompt:r,onInteractOutside:a?u=>{u.preventDefault()}:void 0,children:[qe(Ki,{children:[qe(qi,{children:[o,z(p.SectionHeader,{children:e})]}),!i&&z(I.DialogClose,{asChild:!0,children:z(P,{icon:K})})]}),l]})]}),Gt=_i`
    @media (max-width: ${m.small}) {
        /* layout */
        width: 100%;
    }
`,Qi=T(q).attrs({$variant:"large"})`
    /* layout */
    ${Gt}
`,Yi=T(E).attrs({$variant:"large"})`
    /* layout */
    ${Gt}
`,ji=T(ze).attrs({$variant:"large"})`
    /* layout */
    ${Gt}
`,vr=({children:e,variant:o,closeOnSubmit:r=!0,...a})=>{let i=(()=>{switch(o){case"primary":return Qi;case"secondary":return Yi;case"destructive":return ji}})();return r&&a.type!=="submit"?z(I.DialogClose,{asChild:!0,children:z(i,{...a,children:e})}):z(i,{...a,children:e})},el=T(ar)`
    color: ${({theme:e})=>e.alert};
`,tl=T(p.Secondary)`
    display: flex;
    justify-content: flex-end;
    margin-top: -1.75rem;

    color: ${({theme:e})=>e.alert};

    @media (max-width: ${m.small}) {
        justify-content: flex-start;
        margin-top: -${n[150]};
    }
`,ol={ActionButton:vr,ActionErrorMessage:tl,ButtonsSection:Ji,Content:yr,Form:hr,Root:br,Trigger:xr,WarningIcon:el},rl=T.section`
    display: grid;
    gap: ${s.horizontalComponentGap};
`,nl=({children:e,...o})=>z(yr,{...o,flowPrompt:!0,children:e});function al({children:e,variant:o,...r}){return z(vr,{variant:o,$fluid:!0,...r,children:e})}var il={ActionButton:al,IconButton:P,ButtonsSection:rl,Content:nl,Form:hr,Root:br,Trigger:xr};import*as Je from"@radix-ui/react-switch";import Ft from"styled-components";import{jsx as Sr,jsxs as ml}from"react/jsx-runtime";var sl=Ft(Je.Root)`
    /* reset */
    transition: background-color 0.3s;
    border: none;
    cursor: pointer;

    /* layout */
    position: relative;
    width: 2.25rem;
    height: 1rem;

    /* appearance */
    background-color: ${({theme:e})=>e.toggle.off.defaultTrack};
    border-radius: ${d.round};

    &[data-state='checked'] {
        background-color: ${({theme:e})=>e.toggle.on.defaultTrack};
    }

    &[data-disabled] {
        cursor: not-allowed;
        background-color: ${({theme:e})=>e.toggle.off.disabledTrack};
    }
    &[data-state='checked'][data-disabled] {
        background-color: ${({theme:e})=>e.toggle.on.disabledTrack};
    }

    &:hover:not(:has([data-disabled])) {
        background-color: ${({theme:e})=>e.toggle.off.hoverTrack};
        span {
            background-color: ${({theme:e})=>e.toggle.off.hoverHandle};
        }

        &[data-state='checked'] {
            background-color: ${({theme:e})=>e.toggle.on.hoverTrack};
            span {
                background-color: ${({theme:e})=>e.toggle.on.hoverHandle};
            }
        }
    }
`,dl=Ft(Je.Thumb)`
    /* reset */
    transition-property: transform, background-color;
    transition-duration: 0.3s;
    will-change: transform;

    /* layout */
    position: absolute;
    top: -0.125rem; // (track height - thumb height) / 2
    left: 0;
    width: 1.25rem;
    height: 1.25rem;

    /* appearance */
    background-color: ${({theme:e})=>e.toggle.off.defaultHandle};
    border-radius: ${d.round};
    box-shadow: ${ho} ${({theme:e})=>e.toggle.shadow};

    &[data-state='checked'] {
        background-color: ${({theme:e})=>e.toggle.on.defaultHandle};
        transform: translateX(1rem);
    }

    &[data-disabled] {
        cursor: not-allowed;
        background-color: ${({theme:e})=>e.toggle.off.disabledHandle};
    }

    &[data-state='checked'][data-disabled] {
        background-color: ${({theme:e})=>e.toggle.on.disabledHandle};
    }
`,cl=Ft.label`
    /* reset */
    cursor: pointer;
    user-select: none;
    transition: color 0.3s;

    /* content */
    ${h}

    /* layout */
    display: flex;
    align-items: center;
    gap: 1rem;

    color: ${({theme:e})=>e.mainText};

    /* appearance */
    &:has([data-disabled]) {
        cursor: not-allowed;
        color: ${({theme:e})=>e.disabledContent};
    }
`,pl=({children:e,name:o,...r})=>ml(cl,{htmlFor:o,children:[Sr(sl,{...r,name:o,children:Sr(dl,{})}),e]});import*as Qe from"@radix-ui/react-tooltip";import Vt from"styled-components";import ul from"styled-components";var Pr=ul(Z)`
    /* variants */
    color: ${({theme:e})=>e.accent};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.blueHover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.bluePress};
    }
`;var Ye=Vt(Qe.Content)`
    /* layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    max-width: 400px;
    padding: ${n[25]};

    /* content */
    ${h}
    color: ${({theme:e})=>e.tooltips.content};

    /* appearance */
    background-color: ${({theme:e})=>e.tooltips.fill};
    border-radius: ${d.small};
    outline: none;
    box-shadow: ${({theme:e})=>`${ne} ${e.tooltips.shadow}`};

    @media (max-width: ${m.small}) {
        /* layout */
        max-width: calc(100vw - 2 * ${n[100]});
        flex-direction: column;
    }
`,je=Vt.p`
    margin: 0;
    padding: ${n[25]} ${n[50]};
`,$r=Vt(Pr).attrs({$variant:"small"})`
    align-self: end;
`,gl=Qe.Provider;import fl from"styled-components";import*as ce from"@radix-ui/react-tooltip";import{useState as hl}from"react";import{jsx as et,jsxs as wr}from"react/jsx-runtime";var bl=fl(ce.Trigger)`
    padding: 0;
    border: 0;
    background-color: transparent;
`;function xl({children:e,description:o,actionButtonText:r,onActionButtonClick:a,openDelay:i=500,...l}){let[g,u]=hl(!1);return wr(ce.Root,{delayDuration:i,open:g,onOpenChange:u,children:[et(bl,{onClick:()=>{u(x=>!x)},onFocus:()=>setTimeout(()=>{u(!0)},0),onBlur:x=>{x.preventDefault()},children:e}),et(ce.Portal,{children:wr(Ye,{side:"bottom",sideOffset:4,collisionPadding:8,...l,children:[et(je,{children:o}),et($r,{onPress:a,children:r})]})})]})}import me from"styled-components";import*as G from"@radix-ui/react-tooltip";import{useEffect as yl,useState as vl}from"react";import{jsx as pe,jsxs as Br}from"react/jsx-runtime";var Sl=me(G.Trigger)`
    padding: 0;
    border: 0;
    background-color: transparent;
`,Pl=me(Ye)`
    padding: ${n[75]} ${n[100]};
    flex-direction: column;
    background-color: ${({theme:e})=>e.hint.fill};
    color: ${({theme:e})=>e.hint.content};
    z-index: ${({$zIndex:e})=>e??"auto"};
`,$l=me(je)`
    align-self: flex-start;
    padding: 0;
`,wl=me.section`
    height: 1px;
    width: 100%;
    background-color: ${({theme:e})=>e.hint.content};
    margin: ${n[50]} 0;
`,Bl=me(Z).attrs({$variant:"small"})`
    min-width: fit-content;
    align-self: end;
    justify-self: flex-end;
    color: ${({theme:e})=>e.hint.content};
`,Tl=me(G.Arrow)`
    fill: ${({theme:e})=>e.hint.fill};
`,Cl=G.Provider;function kl({children:e,description:o,actionButtonText:r,onActionButtonClick:a,zIndex:i,...l}){let[g,u]=vl(!0);return yl(()=>{u(!0)},[]),Br(G.Root,{delayDuration:0,open:g,children:[pe(Sl,{asChild:!0,children:e}),pe(G.Portal,{children:Br(Pl,{side:"bottom",sideOffset:4,collisionPadding:8,forceMount:!0,$zIndex:i,...l,children:[pe(Tl,{}),pe($l,{children:o}),pe(wl,{}),pe(Bl,{onPress:()=>{a()},children:r})]})})]})}import Tr from"styled-components";import{jsx as Lt}from"react/jsx-runtime";var Rl=Tr.span`
    /* reset */
    ${y}

    /* layout */
    ${ee}
    padding-inline: 0;
    justify-content: center;

    /* appearance */
    ${ye}
    width: ${j("small")};
    min-width: ${j("small")};
    height: ${j("small")};

    background-color: transparent;
    color: ${({theme:e})=>e.buttons.embedded.contentOnDark};
    border-color: transparent;
`,Il=Tr(v).attrs({$variant:"medium"})`
    background: transparent;
    padding: 0 ${n[75]};

    border-radius: 0;
    border-width: 0;
    border-style: none;

    width: ${({$width:e})=>e};
    height: ${({$height:e})=>e};

    ${({$iconPosition:e})=>{switch(e){case"left":return"justify-content: flex-start;";case"right":return"justify-content: flex-end;"}}}

    &[data-hovered] .iconWrapper {
        background-color: ${({theme:e})=>e.buttons.embedded.hoverOnDark};
    }
    &[data-pressed] .iconWrapper {
        background-color: ${({theme:e})=>e.buttons.embedded.pressedOnDark};
    }
    &[data-disabled] .iconWrapper {
        cursor: not-allowed;
        color: ${({theme:e})=>e.buttons.embedded.disabledContent};
    }
`,Al=({icon:e,width:o,height:r,iconPosition:a,...i})=>Lt(Il,{...i,$width:o,$height:r,$iconPosition:a,children:Lt(Rl,{className:"iconWrapper",children:Lt(e,{color:"currentColor"})})});import Vl from"styled-components";import*as ue from"@radix-ui/react-radio-group";import tt from"styled-components";import{forwardRef as Dl}from"react";import{jsx as zt,jsxs as Fl}from"react/jsx-runtime";var Ml=tt.div`
    ${y}

    display: flex;
    align-items: flex-start;
`,El=tt(ue.Item)`
    all: unset;

    width: 16px;
    height: 16px;
    /* prevent icon from resizing on screen width change */
    min-width: 16px;
    min-height: 16px;

    border-radius: 100%;
    border: 1px solid ${({theme:e})=>e.radioButton.defaultFill};
    background-color: white;

    &:hover,
    &:focus {
        border: 1px solid ${({theme:e})=>e.radioButton.hover};
    }
`,Hl=tt(ue.Indicator)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    width: 100%;
    height: 100%;

    &::after {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${({theme:e})=>e.radioButton.defaultFill};
    }
`,Gl=tt.label`
    cursor: pointer;
    user-select: none;
    margin-left: ${s.innerGap};

    ${h}
    color: ${({theme:e})=>e.mainText};

    &:hover,
    &:focus {
        color: ${({theme:e})=>e.radioButton.hover};
    }
`,Cr=Dl(({label:e,id:o},r)=>Fl(Ml,{ref:r,children:[zt(El,{value:o,id:o,children:zt(Hl,{})}),zt(Gl,{htmlFor:o,children:e})]}));Cr.displayName="RadioItem";var ge={Root:ue.Root,Item:Cr};var Ll=Vl(ge.Root)`
    display: flex;
    flex-direction: row;

    gap: ${n[125]};

    @media (max-width: ${m.small}) {
        gap: ${n[100]};
    }
`,zl={Root:Ll,Item:ge.Item};import Kl from"styled-components";import{forwardRef as Wl}from"react";import Wt from"styled-components";import{jsx as J,jsxs as kr}from"react/jsx-runtime";var Ul=Wt.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`,Ol=Wt(p.Paragraph)`
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: ${s.horizontalComponentGap};
    align-items: center;
`;function Nl({cardBrand:e}){switch(e){case"visa":return J(rr,{});case"mastercard":return J(Yo,{});case"other":default:return J(kt,{})}}function _l({cardBrand:e,cardLast4:o,expMonth:r,expYear:a,editButton:i}){let l=`0${r}`.slice(-2),g=a.toString().slice(-2),u=`${l}/${g}`;return kr(Ul,{children:[kr(Ol,{children:[J(Nl,{cardBrand:e}),J("span",{"aria-label":`Credit card ending in ${o}`,children:`XXXX-XXXX-XXXX-${o}`}),J("span",{"aria-label":"Expiration date",children:u})]}),i]})}var Zl=Wt(E).attrs({$variant:"small"})`
    @media (max-width: ${m.small}) {
        ${N}

        .button-text {
            display: none;
        }
    }
`,ot=Wl(({text:e,...o},r)=>J(Zl,{icon:er,...o,ref:r,children:J("span",{className:"button-text",children:e})}));ot.displayName="EditablePaymentMethod.EditButton";var Xl={Info:_l,EditButton:ot};var ql=Kl(ge.Root)`
    display: flex;
    flex-direction: column;

    gap: ${n[150]};
`,Jl={Root:ql,Item:ge.Item,EditButton:ot};import{Elements as Ql,PaymentElement as Yl,useElements as jl,useStripe as es}from"@stripe/react-stripe-js";import{useTheme as ts}from"styled-components";import{useState as os}from"react";import{jsx as Rr}from"react/jsx-runtime";function rs({children:e,stripe:o,clientSecret:r}){let a=ts();return Rr(Ql,{options:{clientSecret:r,appearance:{theme:"stripe",variables:{fontFamily:"Lato, sans-serif",fontSizeBase:"1rem",fontWeightNormal:"400",colorText:a.mainText,borderRadius:d.small,gridRowSpacing:n[50]},rules:{".Label":{textTransform:"uppercase",fontSize:"0.75rem",fontWeight:"700",color:a.notes,margin:`0 0 0 ${n[50]}`},".Label--invalid":{color:a.alert},".Input":{borderColor:a.stroke.light,borderWidth:"1px",padding:`${n[75]} ${n[50]}`},".Input:focus":{borderColor:a.focus,boxShadow:"none"},".Input--invalid:focus":{borderColor:a.alert,boxShadow:"none"},".Input::placeholder":{color:a.notes},".Error":{fontSize:"0.75rem",lineHeight:"normal",color:a.alert,margin:`0 0 0 ${n[50]}`},".TermsText":{fontSize:"0.75rem",color:a.notes}}}},stripe:o,children:e})}function ns(e){return Rr(Yl,{...e,options:{fields:{billingDetails:"never"},wallets:{applePay:"never",googlePay:"never"}}})}var as=()=>{let e=es(),o=jl(),[r,a]=os(!1);return{isLoading:r,handleSubmitPaymentMethod:async l=>{if(l.preventDefault(),!e||!o)return{error:"Stripe.js has not yet loaded"};a(!0);let g=await e.confirmSetup({elements:o,confirmParams:{payment_method_data:{billing_details:{name:null,email:null,phone:null,address:{city:null,country:null,line1:null,line2:null,postal_code:null,state:null}}}},redirect:"if_required"});return a(!1),g.error?{error:`Confirm setup intent failed: ${g.error.message}`}:{data:g.setupIntent}}}};import W from"styled-components";import{jsx as C,jsxs as A}from"react/jsx-runtime";var rt=W.section`
    height: 64px;
    max-width: 640px;

    padding: ${s.horizontalComponentGap};
    border-radius: ${d.small};
    border: 1px solid ${({theme:e})=>e.stroke.light};

    display: grid;
    align-items: center;
    row-gap: 0.5rem;
    column-gap: 0.5rem;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'size action' 'price_and_source billing';

    @media (max-width: ${m.small}) {
        height: fit-content;
        max-width: 100%;

        grid-template-areas: 'size action' 'price_and_source billing';
    }
`,nt=W(p.SectionHeader)`
    ${no}
    grid-area: size;
    width: fit-content;
`,at=W.div.attrs({role:"none"})`
    grid-area: price_and_source;
    display: flex;
    flex-direction: row;
    column-gap: 0.5rem;

    @media (max-width: ${m.small}) {
        flex-direction: column;
        row-gap: 0.5rem;
    }
`,Ut=W(p.Paragraph)`
    grid-area: price;
    align-self: center;

    @media (max-width: ${m.small}) {
        align-self: start;
    }
`,it=W(p.Secondary)`
    grid-area: source;
    ${O}

    align-self: center;

    @media (max-width: ${m.small}) {
        align-self: start;
    }
`,Ot=W(p.Paragraph)`
    grid-area: billing;

    color: ${({theme:e,alert:o})=>o?e.alert:e.mainText};

    justify-self: end;
`,is=W(E).attrs({$variant:"small"})`
    grid-area: action;
    justify-self: end;
`,ls=W(q).attrs({$variant:"small"})`
    grid-area: action;
    justify-self: end;
`,ss=W.div.attrs({role:"none"})`
    grid-area: action;
    justify-self: end;
    width: 104px;
`,ds=({sizeText:e,sourceText:o})=>A(rt,{children:[C(nt,{children:e}),C(at,{children:A(it,{children:["(",o,")"]})})]}),cs=({sizeText:e,sourceText:o,priceText:r,billingInfoText:a,children:i})=>A(rt,{children:[C(nt,{children:e}),A(at,{children:[r&&C(Ut,{children:r}),A(it,{children:["(",o,")"]})]}),C(Ot,{children:a}),i]}),ps=({sizeText:e,sourceText:o,priceText:r,billingInfoText:a,children:i})=>A(rt,{children:[C(nt,{children:e}),A(at,{children:[C(Ut,{children:r}),A(it,{children:["(",o,")"]})]}),C(Ot,{alert:!0,children:a}),i]}),ms=({sizeText:e,sourceText:o,priceText:r,billingInfoText:a})=>A(rt,{children:[C(nt,{children:e}),A(at,{children:[r&&C(Ut,{children:r}),A(it,{children:["(",o,")"]})]}),C(Ot,{alert:!0,children:a}),C(ss,{})]});import Nt from"styled-components";import{jsx as Ir,jsxs as bs}from"react/jsx-runtime";var us=Nt(p.Subheader)`
    color: ${({theme:e})=>e.mainText};
    font-size: 2rem;
`,gs=Nt(p.Paragraph)`
    color: ${({theme:e})=>e.secondaryText};
    font-size: 1.5rem;
`,fs=Nt.section`
    display: grid;
    grid-row-gap: ${s.innerGap};
`,hs=({sizeText:e,priceText:o})=>bs(fs,{children:[Ir(us,{children:e}),Ir(gs,{children:o})]});import b from"styled-components";import{forwardRef as xs}from"react";import{jsx as f,jsxs as ke}from"react/jsx-runtime";var Er=(l=>(l.Available="available",l.Unavailable="unavailable",l.Selected="selected",l.Active="active",l.Upcoming="upcoming",l))(Er||{}),ys=b.table`
    width: 100%;
    max-width: 640px;
    display: grid;
    row-gap: ${s.horizontalComponentGap};
`,vs=b.tbody`
    display: grid;
    row-gap: ${s.horizontalComponentGap};
`,_t=b.th.attrs({scope:"col"})`
    text-align: center;
    height: fit-content;
`,Hr=b.tr`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr minmax(auto, 200px) minmax(auto, 200px);
    column-gap: ${s.horizontalComponentGap};
`,Ss=b(Hr)`
    font-weight: 700;
`,Ps=b.th.attrs({scope:"row"})`
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    min-width: 65px;
`,Ar=b.td`
    text-align: center;
`,$s=b(E).attrs({$variant:"large",$fluid:!0})`
    background-color: ${({theme:e})=>e.bluePress};
    &[data-hovered] {
        background-color: ${({theme:e})=>e.bluePress};
    }
`,ws=b(te).attrs({$variant:"large",$fluid:!0,isDisabled:!0})``,Bs=b(te).attrs({$variant:"large",$fluid:!0})``,Ts=b(te).attrs({$variant:"large",$fluid:!0,isDisabled:!0})`
    &[data-disabled] {
        background-color: ${({theme:e})=>e.buttons.teritary.default};
        color: ${({theme:e})=>e.buttons.teritary.content};
        border-color: ${({theme:e})=>e.stroke.dark2};
    }
`,Cs=b(te).attrs({$variant:"large",$fluid:!0,isDisabled:!0})`
    &[data-disabled] {
        color: ${({theme:e})=>e.buttons.teritary.content};
        background-color: ${({theme:e})=>e.buttons.teritary.pressed};
    }
`,Ce=b.span`
    white-space: initial;
`,Dr=b.span`
    white-space: nowrap;
`;function Mr({onPress:e,type:o,label:r,tag:a}){switch(o){case"selected":return f($s,{children:f(Ce,{children:r})});case"unavailable":return f(ws,{children:f(Ce,{children:r})});case"active":return f(Ts,{children:ke(Ce,{children:[f(Dr,{children:r}),` (${a})`]})});case"upcoming":return f(Cs,{children:ke(Ce,{children:[f(Dr,{children:r}),` (${a})`]})});case"available":return f(Bs,{onPress:e,children:f(Ce,{children:r})})}}function ks({headers:[e,o,r],plans:a,onChoosePlan:i}){return ke(ys,{children:[f("thead",{children:ke(Ss,{children:[f(_t,{children:e}),f(_t,{children:o}),f(_t,{children:r})]})}),f(vs,{children:a.map(({storage:l,monthlyPlan:g,yearlyPlan:u},x)=>ke(Hr,{children:[f(Ps,{children:l}),f(Ar,{children:f(Mr,{type:g.type,onPress:()=>{i(g.id)},label:g.label,tag:g.tag})}),f(Ar,{children:f(Mr,{type:u.type,onPress:()=>{i(u.id)},label:u.label,tag:u.tag})})]},x))})]})}var Gr=xs(({label:e,...o},r)=>f(q,{$variant:"large",$fluid:!0,...o,ref:r,children:e}));Gr.displayName="SubscriptionsGrid.SubmitButton";var Rs=b.p`
    ${O}
    color: ${({theme:e})=>e.secondaryText};
    margin: 0;
`,Is={PlansTable:ks,SubmitButton:Gr,ChangePlanPeriodNote:Rs};import Q from"styled-components";import{jsx as F,jsxs as Zt}from"react/jsx-runtime";var As=Q.table`
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    width: 100%;
    display: grid;

    color: ${({theme:e})=>e.secondaryText};
`,Xt=Q.th`
    display: flex;
    height: 100%;

    align-items: center;
    justify-content: center;

    font-weight: 400;
`,Ds=Q(Xt)`
    background-color: ${({theme:e})=>e.emptyStateCard};
    border-radius: '4px 4px 0 0';
    border-bottom: 2px solid ${({theme:e})=>e.stroke.dark};
`,Fr=Q.tr`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 96px 96px;
    grid-auto-rows: minmax(40px, auto);

    border-bottom: 1px solid ${({theme:e})=>e.stroke.dark};
`,Ms=Q(Fr)`
    align-items: center;
`,Es=Q.th`
    display: flex;
    justify-content: left;
    align-items: center;

    min-width: 96px;

    font-weight: 400;
`,Vr=Q.td`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: ${({theme:e})=>e.accent};
`,Hs=Q(Vr)`
    background-color: ${({theme:e})=>e.emptyStateCard};
`,Gs=({perkTitle:e,perkDetails:o})=>Zt(As,{children:[F("thead",{children:Zt(Ms,{children:[F(Xt,{}),F(Xt,{children:e.free}),F(Ds,{children:e.sub})]})}),F("tbody",{children:o.map(r=>Zt(Fr,{children:[F(Es,{children:r.text}),F(Vr,{children:r.free&&F(Ne,{color:"currentcolor"})}),F(Hs,{children:r.sub&&F(Ne,{color:"currentcolor"})})]},r.text))})]});export{fn as Accordion,xn as AccordionItem,xl as ActionableTooltip,cs as ActiveSubscriptionInfo,Se as AlbumThumbnail,qn as Badge,Xn as BadgeGroup,ta as BadgeSelect,le as BadgeText,Sa as BottomSheet,Pa as BottomSheetTrigger,is as CancelSubscriptionButton,ps as CanceledSubscriptionInfo,Ca as Checkbox,Aa as ChoiceDrawer,Da as ChoiceDrawerItem,Nn as CollectionsThumbnail,Li as ContentLoader,Ha as ContextMenu,ni as DataUsageBar,Jl as DigitalLegacyRadioGroup,R as DropdownMenu,Xl as EditablePaymentMethod,Al as EmbeddedAreaIconOnDarkSurfaceButton,P as EmbeddedIconButton,li as ErrorMessage,ui as FileInfoEntry,il as FlowPrompt,Di as Form,ds as GrantedSubscriptionInfo,kl as Hint,Cl as HintProvider,zl as HorizontalRadioGroup,na as LinkButton,fr as Loader,Qa as MePageUsageDescription,Go as NavBarButton,ms as OverridedSubscriptionInfo,Ui as PageCard,ua as PageNeutralButton,ca as PagePrimaryButton,ma as PagePrimaryDestructiveButton,pa as PageSecondaryButton,ja as ProgressBar,ol as Prompt,hs as PurchaseProductInfo,ls as ResubscribeSubscriptionButton,Ni as ShortcutPageCard,vi as SideDrawer,Er as StoragePlanType,rs as StripeElements,ns as StripePaymentElement,Gs as SubscriptionPerkTable,Is as SubscriptionsGrid,wo as ThumbnailExpandPreviewButton,pl as Toggle,xa as ToolBarIconButton,gl as TooltipProvider,p as Typography,Kr as lightTheme,as as useStripeSetupIntent};
//# sourceMappingURL=index.mjs.map